import config from 'eflex/config/environment';
import Model, { attr, belongsTo } from '@ember-data/model';
import { tracked } from '@glimmer/tracking';

export default class HostedFile extends Model {
  @attr('string') name;
  @attr('string') mime;
  @belongsTo('work-instruction-folder', { async: false, inverse: null }) folder;

  @tracked isSelected = false;

  get url() {
    const extension = this.name.split('.').pop();

    return `${config.servicePrefix}/hostedFiles/${this.id}.${extension}`;
  }

  get isFile() {
    return true;
  }
}
